<template>
  <div>
    <div class="title">
      <h3>{{ title }}</h3>
      <div class="filter">
        <a-radio-group v-if="!hideDays" v-model="dateSelect" @change="changeDateSelect">
          <a-radio :value="1">日</a-radio>
          <a-radio :value="2">月</a-radio>
        </a-radio-group>
        <a-range-picker
          @change="changeDate"
          v-model="dataRange"
          :disabled-date="disabledDate"
          :format="dateSelect === 1 ? undefined : 'YYYY-MM'"
          :mode="dateSelect === 1 ? undefined : ['month', 'month']"
          @panelChange="onPanelChange"
          @calendarChange="onCalendarChange"
          @openChange="onOpenChange"
          :getCalendarContainer="triggerNode => triggerNode.parentNode"
        ></a-range-picker>
      </div>
    </div>
    <div class="chart-body" ref="chart"></div>
    <a class="shift-display" @click="_shiftDisplay">切换数据详情</a>
  </div>
</template>
<script>
import * as echarts from 'echarts/core'
import moment from 'moment'
import { EN_DATE_SELECT } from '../index.vue'
import { message } from 'ant-design-vue'
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    range: {
      type: Array,
      default: function() {
        return []
      }
    },
    select: {
      type: Number,
      default: 0
    },
    option: {
      type: Object,
      default: function() {
        return {}
      }
    },
    hideDays: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chart: echarts.chart,
      dataRange: [],
      dateSelect: EN_DATE_SELECT.MONTH,
      displayFlag: true,
      selectDate: []
    }
  },
  created() {},
  mounted() {
    const chart = echarts.init(this.$refs.chart, undefined, { height: 300 })
    this.chart = chart
    chart.getZr().on('click', params => {
      const pointInPixel = [params.offsetX, params.offsetY]
      if (chart.containPixel('grid', pointInPixel)) {
        let xIndex = chart.convertFromPixel({ seriesIndex: 0 }, [params.offsetX, params.offsetY])[0]
        const date = chart.getOption().xAxis[0].data[xIndex]
        this.$emit('showDetail', this.dateSelect === EN_DATE_SELECT.DAY ? date : `${date}/01`)
      }
    })
    window.addEventListener('resize', this._resize)
  },
  destoryed() {
    window.removeEventListener('resize', this._resize)
  },
  computed: {
    chartOption() {
      return this.option
    }
  },
  watch: {
    option: function() {
      this.renderChart()
    },
    range: function() {
      this.dataRange = this.range
    },
    select: function() {
      this.dateSelect = this.select
    }
  },
  methods: {
    disabledDate(current) {
      if (!this.selectDate || this.selectDate.length === 0) {
        return false
      }
      const tooLate = this.selectDate[0] && current.diff(this.selectDate[0], 'days') > 15
      const tooEarly = this.selectDate[1] && this.selectDate[1].diff(current, 'days') > 15
      return tooEarly || tooLate
    },
    onOpenChange(open) {
      if (open) {
        this.selectDate = []
      }
    },
    onCalendarChange(val) {
      this.selectDate = val
    },
    onPanelChange(params) {
      if (params[1].diff(params[0], 'month') > 15) {
        message.warning('请选择少于15个月的区间')
        return
      }
      this.dataRange = params
      this.$emit('changeDate', { select: this.dateSelect, range: this.dataRange })
    },
    async renderChart() {
      if (this.displayFlag) {
        this.chartOption.series[0].label = {
          show: true,
          position: 'top'
        }
        this.chartOption.series[1].label = undefined
      } else {
        this.chartOption.series[1].label = {
          show: true,
          position: 'top'
        }
        this.chartOption.series[0].label = undefined
      }
      this.chart.setOption(this.chartOption)
    },
    changeDateSelect() {
      let start
      let end
      if (this.dateSelect === EN_DATE_SELECT.DAY) {
        end = moment('2022/06/30')
        start = moment('2022/06/30').add(-15, 'days')
      } else {
        end = moment().add(-1, 'months')
        start = moment().add(-12, 'months')
      }
      this.dataRange = [start, end]

      this.changeDate()
    },
    changeDate() {
      this.$emit('changeDate', { select: this.dateSelect, range: this.dataRange })
    },
    _shiftDisplay() {
      this.displayFlag = !this.displayFlag
      this.renderChart()
    },
    _resize() {
      this.chart.resize()
    }
  }
}
</script>
<style lang="less"></style>
